import {
  FETCH_WALLET_CASHOUTS_DATA,
  FETCH_WALLET_CASHOUTS_SUCCESS,
  FETCH_WALLET_CASHOUTS_FAILURE,
  CREATE_WALLET_CASHOUT_DATA,
  CREATE_WALLET_CASHOUT_SUCCESS,
  CREATE_WALLET_CASHOUT_FAILURE,
  APPROVE_WALLET_CASHOUT_DATA,
  APPROVE_WALLET_CASHOUT_SUCCESS,
  APPROVE_WALLET_CASHOUT_FAILURE,
  REJECT_WALLET_CASHOUT_DATA,
  REJECT_WALLET_CASHOUT_SUCCESS,
  REJECT_WALLET_CASHOUT_FAILURE,
  COMPLETE_WALLET_CASHOUT_DATA,
  COMPLETE_WALLET_CASHOUT_SUCCESS,
  COMPLETE_WALLET_CASHOUT_FAILURE,
  CANCEL_WALLET_CASHOUT_DATA,
  CANCEL_WALLET_CASHOUT_SUCCESS,
  CANCEL_WALLET_CASHOUT_FAILURE,
  RESET_WALLET_CASHOUT_STATE,
} from "./actionTypes";

const initialState = {
  loading: false,
  data: null,
  error: null,
  createLoading: false,
  createError: null,
  createSuccess: false,
  actionLoading: false,
  actionError: null,
  actionSuccess: false,
};

const walletCashout = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_WALLET_CASHOUTS_DATA:
      return { ...state, loading: true, error: null };
    case FETCH_WALLET_CASHOUTS_SUCCESS:
      return { ...state, loading: false, data: action.payload };
    case FETCH_WALLET_CASHOUTS_FAILURE:
      return { ...state, loading: false, error: action.payload };

    case CREATE_WALLET_CASHOUT_DATA:
      return { ...state, createLoading: true, createError: null, createSuccess: false };
    case CREATE_WALLET_CASHOUT_SUCCESS:
      return { ...state, createLoading: false, createSuccess: true, createError: null };
    case CREATE_WALLET_CASHOUT_FAILURE:
      return { ...state, createLoading: false, createError: action.payload, createSuccess: false };

    case APPROVE_WALLET_CASHOUT_DATA:
    case REJECT_WALLET_CASHOUT_DATA:
    case COMPLETE_WALLET_CASHOUT_DATA:
    case CANCEL_WALLET_CASHOUT_DATA:
      return { ...state, actionLoading: true, actionError: null, actionSuccess: false };
    case APPROVE_WALLET_CASHOUT_SUCCESS:
    case REJECT_WALLET_CASHOUT_SUCCESS:
    case COMPLETE_WALLET_CASHOUT_SUCCESS:
    case CANCEL_WALLET_CASHOUT_SUCCESS:
      return { ...state, actionLoading: false, actionSuccess: true };
    case APPROVE_WALLET_CASHOUT_FAILURE:
    case REJECT_WALLET_CASHOUT_FAILURE:
    case COMPLETE_WALLET_CASHOUT_FAILURE:
    case CANCEL_WALLET_CASHOUT_FAILURE:
      return { ...state, actionLoading: false, actionError: action.payload, actionSuccess: false };

    case RESET_WALLET_CASHOUT_STATE:
      return { ...state, createSuccess: false, actionSuccess: false, createError: null, actionError: null };

    default:
      return state;
  }
};

export default walletCashout;

